// Mail Template Util
import _ from 'lodash'

import IntlUtil from './intlutil.jsx'

class MailtemplateUtil {
  getRenderObject (mailTemplate) {
    const newTemplate = {
      id: mailTemplate ? mailTemplate.id : null,
      en: [],
      nl: [],
      de: [],
      us: [],
      attachTerms:
        mailTemplate && mailTemplate.attachTerms
          ? mailTemplate.attachTerms
          : []
    }

    if (mailTemplate.en) {
      mailTemplate.en.map((tempObj) => {
        const newObj = _.cloneDeep(tempObj)
        newObj.subject = this._translatedContent('en', tempObj.subject)
        newObj.content = this._translatedContent('en', tempObj.content)

        newTemplate.en.push(newObj)
      })
    }

    if (mailTemplate.nl) {
      mailTemplate.nl.map((tempObj) => {
        const newObj = _.cloneDeep(tempObj)
        newObj.subject = this._translatedContent('nl', tempObj.subject)
        newObj.content = this._translatedContent('nl', tempObj.content)

        newTemplate.nl.push(newObj)
      })
    }

    if (mailTemplate.de) {
      mailTemplate.de.map((tempObj) => {
        const newObj = _.cloneDeep(tempObj)
        newObj.subject = this._translatedContent('de', tempObj.subject)
        newObj.content = this._translatedContent('de', tempObj.content)

        newTemplate.de.push(newObj)
      })
    }

    if (mailTemplate.us) {
      mailTemplate.us.map((tempObj) => {
        const newObj = _.cloneDeep(tempObj)
        newObj.subject = this._translatedContent('us', tempObj.subject)
        newObj.content = this._translatedContent('us', tempObj.content)

        newTemplate.us.push(newObj)
      })
    }

    return newTemplate
  }

  getSaveObject (mailTemplate) {
    const newTemplate = {
      en: [],
      nl: [],
      de: [],
      us: [],
      attachTerms:
        mailTemplate && mailTemplate.attachTerms
          ? mailTemplate.attachTerms
          : []
    }

    if (mailTemplate.en) {
      mailTemplate.en.map((tempObj) => {
        if (!tempObj.bDefault) {
          const newObj = _.cloneDeep(tempObj)
          newObj.subject = this._getSaveContent('en', tempObj.subject)
          newObj.content = this._getSaveContent('en', tempObj.content)

          delete newObj.bDefault
          newTemplate.en.push(newObj)
        }
      })
    }

    if (mailTemplate.nl) {
      mailTemplate.nl.map((tempObj) => {
        if (!tempObj.bDefault) {
          const newObj = _.cloneDeep(tempObj)
          newObj.subject = this._getSaveContent('nl', tempObj.subject)
          newObj.content = this._getSaveContent('nl', tempObj.content)

          delete newObj.bDefault
          newTemplate.nl.push(newObj)
        }
      })
    }

    if (mailTemplate.de) {
      mailTemplate.de.map((tempObj) => {
        if (!tempObj.bDefault) {
          const newObj = _.cloneDeep(tempObj)
          newObj.subject = this._getSaveContent('de', tempObj.subject)
          newObj.content = this._getSaveContent('de', tempObj.content)

          delete newObj.bDefault
          newTemplate.de.push(newObj)
        }
      })
    }

    if (mailTemplate.us) {
      mailTemplate.us.map((tempObj) => {
        if (!tempObj.bDefault) {
          const newObj = _.cloneDeep(tempObj)
          newObj.subject = this._getSaveContent('us', tempObj.subject)
          newObj.content = this._getSaveContent('us', tempObj.content)

          delete newObj.bDefault
          newTemplate.us.push(newObj)
        }
      })
    }

    return newTemplate
  }

  getTranslatedName (lang, variableName) {
    const variables = this._getVariableOptions()
    const variableObj = _.find(
      variables,
      (variable) => variable.value === variableName
    )
    if (variableObj) {
      return variableObj[`${lang}Label`]
    }

    return ''
  }

  getVariablesList (lang) {
    return [
      {
        name: 'CompanyName',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleCompanyName'
        )
      },
      {
        name: 'EstimateNumber',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleEstimateNumber'
        )
      },
      {
        name: 'InvoiceNumber',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleInvoiceNumber'
        )
      },
      {
        name: 'FirstName',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleFirstName'
        )
      },
      {
        name: 'LastName',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleLastName'
        )
      },
      {
        name: 'ProjectName',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleProjectName'
        )
      },
      {
        name: 'ContactPerson',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleContactPerson'
        )
      },
      {
        name: 'Amount',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleAmount'
        )
      },
      {
        name: 'DueDate',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.exampleDueDate'
        )
      },
      {
        name: 'PONumber',
        example: this._translateLabel(
          lang,
          'setting.mailTemplate.examplePurchaseOrderNumber'
        )
      }
    ]
  }

  /* Private functions */
  _getVariableOptions () {
    return [
      {
        value: 'EstimateNumber',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelEstimateNumber'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelEstimateNumber'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelEstimateNumber'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelEstimateNumber'
        )
      },
      {
        value: 'InvoiceNumber',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelInvoiceNumber'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelInvoiceNumber'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelInvoiceNumber'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelInvoiceNumber'
        )
      },
      {
        value: 'FirstName',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelFirstName'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelFirstName'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelFirstName'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelFirstName'
        )
      },
      {
        value: 'LastName',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelLastName'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelLastName'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelLastName'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelLastName'
        )
      },
      {
        value: 'ProjectName',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelProjectName'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelProjectName'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelProjectName'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelProjectName'
        )
      },
      {
        value: 'ContactPerson',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelContactPerson'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelContactPerson'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelContactPerson'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelContactPerson'
        )
      },
      {
        value: 'PONumber',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelPurchaseOrderNumber'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelPurchaseOrderNumber'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelPurchaseOrderNumber'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelPurchaseOrderNumber'
        )
      },
      {
        value: 'CompanyName',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelCompanyName'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelCompanyName'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelCompanyName'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelCompanyName'
        )
      },
      {
        value: 'Amount',
        enLabel: this._translateLabel('en', 'setting.mailTemplate.labelAmount'),
        nlLabel: this._translateLabel('nl', 'setting.mailTemplate.labelAmount'),
        deLabel: this._translateLabel('de', 'setting.mailTemplate.labelAmount'),
        usLabel: this._translateLabel('us', 'setting.mailTemplate.labelAmount')
      },
      {
        value: 'DueDate',
        enLabel: this._translateLabel(
          'en',
          'setting.mailTemplate.labelDueDate'
        ),
        nlLabel: this._translateLabel(
          'nl',
          'setting.mailTemplate.labelDueDate'
        ),
        deLabel: this._translateLabel(
          'de',
          'setting.mailTemplate.labelDueDate'
        ),
        usLabel: this._translateLabel(
          'us',
          'setting.mailTemplate.labelDueDate'
        )
      }
    ]
  }

  _translatedContent (lang, content) {
    return this._parseMailContent(content, 'value', `${lang}Label`)
  }

  _getSaveContent (lang, content) {
    return this._parseMailContent(content, `${lang}Label`, 'value')
  }

  _parseMailContent (content, srcIdent, destIdent) {
    const variables = this._getVariableOptions()
    let newContent = `${content}`
    variables.forEach((varObj) => {
      newContent = newContent.replace(
        new RegExp('\\[\\' + varObj[srcIdent] + '\\]', 'g'),
        `[${varObj[destIdent]}]`
      )
    })

    return newContent
  }

  _translateLabel (lang, ident) {
    return IntlUtil.convertMessageByLanguage(lang, ident)
  }
}

export default new MailtemplateUtil()
